import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import {
	GetProvinces,
	GetCitys,
	GetAreas,
	GetAgentList,
	GetParmConfig, //寄送，支付接口
	GetProductClass,
	GetAgentConsigneeList,
	Consignee_Add,
	GetEmployList,
	ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import viewDialog from './viewDialog/index.vue'

export default {
	mixins: [services],
	components: {
		viewDialog,
	},
	data() {
		return {
			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			// dialogPage: {
			// 	pageIndex: 1,
			// 	pageSize: 10,
			// 	totalSize: '',
			// 	pageSizes: [10, 20, 50],
			// },
			sels: [], //列表选中列
			pageSizes: [10, 20, 50],
			query: this.getFormData(),
			dialogTableVisible: false,
			TableData: []

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				BabyId: "",
				BabyName: "",
				UserName: "",
				PhoneNo: "",
				Customer: "",
				C_name: '',
				SchoolName: ''

			});
		},
		//查看订单
		handleView(index, row) {
			this.$refs.refViewDialog.show({
				BabyId: row.BabyId,
				title: '查看',
			})
		},
		// 
		handOrderNum(row) {
			this.dialogTableVisible = true
			this.GetBabyUserOrderList(row.BabyId)
		},
		//导出api/Baby/BabyExport
		download() {
			this.$confirm('确认导出吗？', '提示', {}).then(() => {
				this.getList();
				var params = {
					Sid: this.$store.state.sysSid,
					Session: this.$store.state.sysSession,
					pageIndex: this.pageIndex,
					pageSize: this.pageSize,
				};
				for (let item in this.query) {
					let value = this.query[item];
					if (value != '') {
						params[item] = value;
					}
				}
				util.exportToFileV2("api/Baby/BabyExport", params, this);
			});
		},
		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		},
		//查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList();
		},
		onQueryClean: function () {
			this.query = this.getFormData();
			this.getList();
		},
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		},
		// // 订单弹窗
		// //查询功能
		// handleSizeChange2: function (val) {
		// 	this.dialogPage.pageSize = val;
		// 	this.getList();
		// },
		// handleCurrentChange2: function (val) {
		// 	this.dialogPage.pageSize = val;
		// 	this.getList();
		// },
	},
	created() {
		this.getList();
	},

}


// WEBPACK FOOTER //
// ./src/pages/Family/StudentsList/vm.js